/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetWorkingTimes200ResponseLocation } from './GetWorkingTimes200ResponseLocation';
import {
    GetWorkingTimes200ResponseLocationFromJSON,
    GetWorkingTimes200ResponseLocationFromJSONTyped,
    GetWorkingTimes200ResponseLocationToJSON,
    GetWorkingTimes200ResponseLocationToJSONTyped,
} from './GetWorkingTimes200ResponseLocation';

/**
 * 
 * @export
 * @interface GetWorkingTimes200Response
 */
export interface GetWorkingTimes200Response {
    /**
     * 
     * @type {GetWorkingTimes200ResponseLocation}
     * @memberof GetWorkingTimes200Response
     */
    location: GetWorkingTimes200ResponseLocation;
    /**
     * 
     * @type {{ [key: string]: GetWorkingTimes200ResponseLocation; }}
     * @memberof GetWorkingTimes200Response
     */
    virtualBrands: { [key: string]: GetWorkingTimes200ResponseLocation; };
}

/**
 * Check if a given object implements the GetWorkingTimes200Response interface.
 */
export function instanceOfGetWorkingTimes200Response(value: object): value is GetWorkingTimes200Response {
    if (!('location' in value) || value['location'] === undefined) return false;
    if (!('virtualBrands' in value) || value['virtualBrands'] === undefined) return false;
    return true;
}

export function GetWorkingTimes200ResponseFromJSON(json: any): GetWorkingTimes200Response {
    return GetWorkingTimes200ResponseFromJSONTyped(json, false);
}

export function GetWorkingTimes200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetWorkingTimes200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'location': GetWorkingTimes200ResponseLocationFromJSON(json['location']),
        'virtualBrands': (mapValues(json['virtualBrands'], GetWorkingTimes200ResponseLocationFromJSON)),
    };
}

export function GetWorkingTimes200ResponseToJSON(json: any): GetWorkingTimes200Response {
    return GetWorkingTimes200ResponseToJSONTyped(json, false);
}

export function GetWorkingTimes200ResponseToJSONTyped(value?: GetWorkingTimes200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'location': GetWorkingTimes200ResponseLocationToJSON(value['location']),
        'virtualBrands': (mapValues(value['virtualBrands'], GetWorkingTimes200ResponseLocationToJSON)),
    };
}

